import React, { useState } from "react";
import { Search } from "lucide-react";
import AdminHeader from "./AdminHeader/AdminHeader";
import SideBarAdmin from "./SideBar/SideBar";
import loadingGif from "../../images/load.gif";
import "./admin.css";

// The shell every admin screen sits in: sidebar, top bar, heading, optional
// search box and loading state. Pages supply only their own content.
const AdminPage = ({
  title,
  subtitle,
  search,
  actions,
  loading = false,
  children,
}) => {
  const [rightHeader, setRightHeader] = useState(false);

  return (
    <div className="admin-shell">
      <SideBarAdmin setRightHeader={setRightHeader} rightHeader={rightHeader} />

      <div className="admin-content">
        <AdminHeader />

        <main className="admin-main">
          <div className="admin-page-head">
            <div>
              <h1 className="admin-page-title">{title}</h1>
              {subtitle && <p className="admin-page-subtitle">{subtitle}</p>}
            </div>
            {actions}
          </div>

          {search && (
            <div className="admin-search">
              <Search size={18} className="admin-search-icon" />
              <input
                className="admin-search-input"
                placeholder={search.placeholder || "Search"}
                value={search.value}
                onChange={(e) => search.onChange(e.target.value)}
              />
            </div>
          )}

          {loading ? (
            <div className="admin-loading">
              <img src={loadingGif} alt="Loading..." />
            </div>
          ) : (
            children
          )}
        </main>
      </div>
    </div>
  );
};

export default AdminPage;
